import React from 'react'
import logo from 'assets/svg/logo-with-circle.svg'

export default function NavbarFixed(props) {
  const { menuItems = [], onButtonClick, buttonText } = props

  const items = menuItems.map((x, index) => {
    return (
      <li key={index} className={['font-light inline-block text-base mr-4', (x.active && 'font-bold')]}>
        <a
          href={x.url}
          className="text-navy hover:underline"
        >
          {x.title}
        </a>
      </li>
    )
  })

  return (
    <div className="h-auto relative md:sticky md:top-0 bg-gray-100 border border-gray-300 py-3 z-50">
      <div className="container mx-auto block md:table w-full">
        <div className="w-1/4 md:w-1/12 table-cell align-middle">
          <a href={'#'} className={['text-navy h-11']}>
            <img src={logo} className="h-12" />
          </a>
        </div>
        <div className="w-1/1 md:w-9/12 table-cell align-middle">
          {items ? <ul>{items}</ul> : ''}
        </div>
        <div className="block w-full md:2/12 md:table-cell text-center align-middle mt-3 md:mt-0">
          <button
            className="block font-platform btn w-full md:w-auto btn-green hover:bg-green text-base px-5 lg:px-6 py-2 md:float-left"
            onClick={onButtonClick}
          >
            {buttonText || "Get Started"}
          </button>
        </div>
      </div>
    </div>
  )
}
